import module from 'nominas/sumario/module.js'
import template from './template.html'
import moment from 'moment'

export class NominasSumarioAgregarConfiguracionComponent {
  agregando = false
  proyectoId
  nominaId
  regimenFiscalId
  tipoNominaId
  idNomina = [null, null, null, null, null]
  fechaMin = moment().subtract(1, 'months').toDate()
  fechaMax = moment().add(1, 'months').toDate()
  fechaInicialMin = moment().subtract(3, 'months').toDate()
  fechaFinalMax = moment().add(3, 'months').toDate()
  conflictoFecha = null
  conflictoFechaInicial = null
  conflictoFechaFinal = null
  catalogos = {}
  consulta = {}
  onClose
  placeholder = ''
  data = {
    id_proyecto: null,
    id_regimen_fiscal: null,
    id_tipo_nomina: null,
    id_moneda: 1,
    tipo_cambio: 1,
    tipo_cambio_fecha: null,
    no_deducible: false,
    omitir_carga_social_pendiente: false,
    id_prorrateo: null,
    id_esquema: null,
    id_nomina: null,
    folio: null,
    cobro_impuesto_estatal: null,
    comision_porcentaje: null,
    comision_porcentaje_op: null,
    comision_porcentaje_sa: null,
    id_metodo_calculo_comision: null,
    id_metodo_calculo_suministro: null,
    id_tipo_comision: null,
    iva_porcentaje: null,
    notas: '',
    fecha: null,
    fecha_inicial: null,
    fecha_final: null,
    fecha_pago: null,
    aplicar_ajuste_impuesto: true,
  }
  validacionesTipoCambio = {
    tipoMoneda: (value) => Number.isFinite(value) === false || (value > 0 && (this.data.id_moneda === 1 || value !== 1)),
  }

  constructor ($q, NominasCatalogoEsquema, NominasCatalogoMonedas, NominasProrrateo, NominasPredeterminado, NominasValidacion) {
    this.$q = $q
    this.NominasCatalogoEsquemaService = NominasCatalogoEsquema
    this.NominasCatalogoMonedasService = NominasCatalogoMonedas
    this.NominasProrrateoService = NominasProrrateo
    this.NominasPredeterminadoService = NominasPredeterminado
    this.NominasValidacionService = NominasValidacion
  }

  $onInit () {
    this.idNomina[0] = this.proyectoId
    this.promise = this.$q.all([
        this.NominasCatalogoMonedasService.get()
          .then((response) => (this.catalogos.monedas = response.data)),
        this.NominasCatalogoEsquemaService.get(this.proyectoId)
          .then((response) => (this.esquema = response.data)),
        this.NominasProrrateoService.get(this.proyectoId)
          .then((response) => (this.prorrateo = response.data)),
        this.NominasPredeterminadoService.get(this.proyectoId, this.nominaId, this.tipoNominaId)
          .then((response) => {
            this.configuracion = response.data.configuracion
            this.data = response.data.predeterminado
          })
          .then(() => {
            if (!this.nominaId) {
              this.data.id_proyecto = this.proyectoId
              this.data.id_regimen_fiscal = this.regimenFiscalId
              this.data.id_tipo_nomina = this.tipoNominaId
              this.definirDescripcion()
            }
          }),
      ])
      .then(() => {
        this.data.aplicar_ajuste_impuesto = true
        this.seleccionarEsquema()
        this.cambiarIdNomina()
      })
  }

  agregar

  calcularFechasNomina () {
    let dia = moment(this.data.fecha_inicial).date()
    switch (this.tipoNominaId || this.data.id_tipo_nomina) {
      case 0:
        this.data.fecha_final = moment(this.data.fecha_inicial).toDate()
        break
      case 1:
        this.data.fecha_final = moment(this.data.fecha_inicial).add(6, 'day').toDate()
        break
      case 3:
        if (dia === 16) {
          this.data.fecha_final = moment(this.data.fecha_inicial).endOf('month').toDate()
        } else {
          this.data.fecha_final = moment(this.data.fecha_inicial).add(14, 'day').toDate()
        }
        break
      case 4:
        if (dia === 1) {
          this.data.fecha_final = moment(this.data.fecha_inicial).endOf('month').toDate()
        } else {
          this.data.fecha_final = moment(this.data.fecha_inicial).add(29, 'day').toDate()
        }
        break
      case 5:
        this.data.fecha_final = moment(this.data.fecha_inicial).add(13, 'day').toDate()
        break
    }
  }

  definirDescripcion () {
    let descripcion = ''
    switch (this.tipoNominaId || this.data.id_tipo_nomina) {
      case 0:
        descripcion = 'Especial'
        break
      case 1:
        descripcion = 'Semanal'
        break
      case 3:
        descripcion = 'Quincenal'
        break
      case 4:
        descripcion = 'Mensual'
        break
      case 5:
        descripcion = 'Catorcenal'
        break
    }
    this.placeholder = descripcion && this.data.fecha && `Nomina ${descripcion} del ${moment(this.data.fecha).format('LL')}`
  }

  seleccionarEsquema () {
    let esquema = this.esquema.find((item) => item.id_esquema === this.data.id_esquema)

    if (!esquema)
      return this.data.id_esquema = undefined
    this.impuestosEsquema = esquema.impuestos
    this.data.cobro_impuesto_estatal = esquema.cobro_impuesto_estatal
    this.data.comision_porcentaje = esquema.comision_porcentaje
    this.data.comision_porcentaje_op = esquema.comision_porcentaje_op
    this.data.comision_porcentaje_sa = esquema.comision_porcentaje_sa
    this.data.id_metodo_calculo_comision = esquema.id_metodo_calculo_comision
    this.data.id_metodo_calculo_suministro = esquema.id_metodo_calculo_suministro
    this.data.id_tipo_comision = esquema.id_tipo_comision
    this.data.metodo_calculo_comision = esquema.metodo_calculo_comision
    this.data.metodo_calculo_suministro = esquema.metodo_calculo_suministro
    this.data.tipo_comision = esquema.tipo_comision
    this.data.iva_porcentaje = esquema.iva_porcentaje
  }

  cambiarIdNomina () {
    this.data.id_nomina = undefined
    this.idNomina[2] = angular.isDate(this.data.fecha) ? ('0' + this.data.fecha.getFullYear()).slice(-2) : null
    this.idNomina[3] = angular.isDate(this.data.fecha) ? ('0' + (this.data.fecha.getMonth() + 1)).slice(-2) : null

    this.$q.when((this.proyectoId && this.data.id_tipo_nomina >= 0 && this.idNomina[2] && this.idNomina[3] && (!this.idNomina[4] || !this.idNomina[1]))
      ? this.NominasValidacionService.obtenerIndice(this.proyectoId, this.data.id_tipo_nomina, this.data.fecha)
      : null)
      .then((response) => {
        this.consulta = (response && response.data) || this.consulta

        this.idNomina[1] = this.data.etiqueta = this.consulta.etiqueta
        this.idNomina[4] = this.data.folio = this.consulta.folio

        if (this.idNomina[1] && this.idNomina[2] && this.idNomina[3] && this.idNomina[4]) {
          this.data.id_nomina = this.idNomina.join('')
        }
      })
      .finally(() => (this.validarFecha()))
  }

  seleccionarFecha () {
    this.idNomina[4] = null
    this.definirDescripcion()
    this.cambiarIdNomina()
  }

  regresar () {
    this.onClose()
  }

  validarFecha (bandera = false) {
    if (this.consulta.fecha > this.data.fecha) {
      this.conflictoFecha = 'Existe una nómina posterior a la fecha que está ingresando'
    } else if (this.consulta.fecha > this.data.fecha_inicial) {
      this.conflictoFecha = 'Existe una nómina posterior a la fecha inicial que está ingresando'
    } else {
      this.conflictoFecha = null
    }

    if (this.data.fecha_inicial < this.fechaInicialMin) {
      this.alertaFechaInicial = 'La fecha inicial de la nómina es tres meses menor a la fecha actual'
    } else if (this.data.fecha_inicial > this.fechaFinalMax) {
      this.alertaFechaInicial = 'La fecha inicial de la nómina es tres meses mayor a la fecha actual'
    } else {
      this.alertaFechaInicial = null
    }

    if (this.data.fecha_final > this.fechaFinalMax) {
      this.alertaFechaFinal = 'La fecha final de la nómina es tres meses mayor a la fecha actual'
    } else {
      this.alertaFechaFinal = null
    }

    if (this.data.fecha < this.fechaMin) {
      this.alertaFecha = 'La fecha de la nómina es un mes menor a la fecha actual'
    } else if (this.data.fecha > this.fechaMax) {
      this.alertaFecha = 'La fecha de la nómina es un mes mayor a la fecha actual'
    } else {
      this.alertaFecha = null
    }

    if (bandera) {
      this.calcularFechasNomina()
    }
  }
}

module.component('nominasSumarioAgregarConfiguracion', {
  controller: NominasSumarioAgregarConfiguracionComponent,
  template,
  bindings: {
    proyectoId: '<',
    nominaId: '<',
    regimenFiscalId: '<',
    tipoNominaId: '<',
    catalogos: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/sumario/components/agregar/configuracion/component.js